'use strict'

import {VIEWS} from '@/views/names'

export default {
    install(Vue, store, router) {
        Vue.prototype.$pageManager = {
            showSuccess(params) {
                toPage(VIEWS.success, params)
            },
            showServicing(params) {
                toPage(VIEWS.servicing, params)
            },
            showClient(params) {
                toPage(VIEWS.client, params)
            },
            showPhone(params) {
                toPage(VIEWS.phone, params)
            },
            showHome(params) {
                toPage(VIEWS.home, params)
            },
            showInit(params) {
                toPage(VIEWS.init, params)
            },
            showSuccessRegistration(params) {
                toPage(VIEWS.successRegistration, params)
            },
            showRegistratorForm(params, query) {
                toPage(VIEWS.preRegistrationFrameProfile, params, query)
            }
        }

        function toPage(view, params = {}, query = {}) {
            // https://github.com/vuejs/vue-router/issues/2881
            router.push({
                name: view.name,
                params: params,
                query: query
            })
                .catch((e) => {
                    // do nothing
                })
        }
    }
}
